export default __webpack_public_path__ + "7b5f429edb81f815739631aa7620d732.svg";